import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Lock } from 'lucide-react';

import { ComplianceTenantProvider } from '@/features/compliance/compliance-tenant-context';
import { useCurrentUserRole } from '@/lib/team';

// Layout de la sección /compliance. Sprint Compliance.
// Owner-only — decisión locked #1. El gate vive acá para que toda la sub-app
// herede la protección sin repetirla en cada child.
//
// Estrategia: usamos useCurrentUserRole() (hook con loading-as-viewer) y
// renderizamos un fallback "no autorizado" si role !== 'owner'. No usamos
// beforeLoad porque ahí no tenemos role disponible sin doble fetch.

export const Route = createFileRoute('/_app/compliance')({
  component: ComplianceLayout,
  beforeLoad: async () => {
    if (typeof window !== 'undefined' && window.location.pathname === '/compliance') {
      throw redirect({ to: '/compliance/rat' });
    }
  },
});

function ComplianceLayout() {
  const role = useCurrentUserRole();

  if (role !== 'owner') {
    return (
      <div
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-lg border py-16 text-center"
        style={{ borderColor: 'var(--color-border)' }}
      >
        <Lock className="h-6 w-6" style={{ color: 'var(--color-fg-subtle)' }} aria-hidden />
        <h2 className="text-base font-semibold" style={{ color: 'var(--color-fg)' }}>
          Acceso restringido
        </h2>
        <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
          El Centro de Auditoría es accesible solo para el owner de la organización.
        </p>
      </div>
    );
  }

  return (
    <ComplianceTenantProvider>
      <Outlet />
    </ComplianceTenantProvider>
  );
}
